import React from "react";
import { NavLink } from "react-router-dom";
import PageHero from "../components/PageHero";
import ImageGallery from "../components/ImageGallery";

function CategoryTabs() {
  return (
    <div className="category-tabs">
      <NavLink end to="/puf-panels">
        Overview
      </NavLink>
      <NavLink to="/puf-panels/specifications">Specifications</NavLink>
      <NavLink to="/puf-panels/projects">Projects</NavLink>
    </div>
  );
}

function PufPanelsOverview() {
  return (
    <div className="page">
      <PageHero
        title="PUF Panels"
        subtitle="Energy-efficient insulated roofing and wall panels for high-performance industrial and commercial buildings."
        imagePlaceholder="PUF Roofing / Wall Panels"
      />
      <CategoryTabs />

      <section className="section">
        <h2>Where PUF Panels Work Best</h2>
        <div className="two-column">
          <ul className="list">
            <li>Industrial sheds & warehouses</li>
            <li>Cold storages & food processing units</li>
            <li>Commercial buildings & showrooms</li>
            <li>Pharma & clean room enclosures</li>
          </ul>
          <p className="muted">
            ROOFTECH designs and installs PUF roofing & wall systems that reduce
            heat gain, lower energy bills, and keep your interiors comfortable.
          </p>
        </div>
      </section>

      <section className="section section-highlight">
        <h2>Key Advantages</h2>
        <div className="chip-grid">
          <div className="chip">Excellent thermal insulation</div>
          <div className="chip">Lightweight & fast installation</div>
          <div className="chip">Low maintenance & long life</div>
          <div className="chip">Fire & weather resistant options</div>
          <div className="chip">Compatible with PEB structures</div>
        </div>
      </section>
    </div>
  );
}

export function PufPanelsSpecs() {
  return (
    <div className="page">
      <PageHero
        title="PUF Panels – Specifications"
        subtitle="Typical technical parameters used for industrial and cold room projects."
        imagePlaceholder="Panel Section / Detail"
      />
      <CategoryTabs />

      <section className="section">
        <h2>Standard Panel Build-Up</h2>
        <div className="spec-grid">
          <div>
            <h3>Core</h3>
            <p>Rigid polyurethane foam with high density for strength.</p>
          </div>
          <div>
            <h3>Facing</h3>
            <p>
              Pre-painted galvanized steel, galvalume or stainless steel, inner
              & outer sheets with multiple profiles.
            </p>
          </div>
          <div>
            <h3>Thickness Range</h3>
            <p>30 mm – 150 mm for roof, wall and cold room applications.</p>
          </div>
          <div>
            <h3>Joint Details</h3>
            <p>Tongue & groove joints with sealants for air & water tightness.</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export function PufPanelsProjects() {
  const galleryItems = [
    { label: "Cold Store Exterior" },
    { label: "Roof Panel Close-up" },
    { label: "Industrial Shed" },
    { label: "Wall Cladding" },
    { label: "Loading Bay Detail" },
    { label: "PEB + PUF Roof" }
  ];

  return (
    <div className="page">
      <PageHero
        title="PUF Panels – Projects"
        subtitle="Sample installations showing how PUF panels perform in different environments."
        imagePlaceholder="Project Montage"
      />
      <CategoryTabs />

      <section className="section">
        <h2>Sample Use Cases</h2>
        <div className="card-grid">
          <div className="card">
            <h3>Cold Storage Facility</h3>
            <p>
              Complete envelope in high-thickness PUF panels with vapor-tight
              joints and insulated doors.
            </p>
          </div>
          <div className="card">
            <h3>Manufacturing Plant</h3>
            <p>
              Combination of PUF roof panels and insulated wall cladding with
              PEB structures.
            </p>
          </div>
          <div className="card">
            <h3>Commercial Showroom</h3>
            <p>
              Clean façade using colour-coated wall panels combined with
              glazing.
            </p>
          </div>
        </div>
      </section>

      <section className="section section-highlight">
        <h2>Project Gallery</h2>
        <p className="muted" style={{ marginBottom: "0.8rem" }}>
          Click any tile to view a larger image. Replace placeholders with real
          site photographs.
        </p>

        <ImageGallery items={galleryItems} />
      </section>
    </div>
  );
}

export default PufPanelsOverview;
